<div class="container-fluid padMob webViewBack padZero bg" style="padding-left: 15px; padding-right: 15px;">
    <div class="row HeadDiv mobView bg">
        <!-- Header -->
        <div class="col-md-12 col-12 col-sm-12 bgWhite padHeder divHeader"  style="padding-bottom: 10px;">
            <span style="font-size: 22px; margin-right: 10px; display: inline-block; cursor: pointer;" class="mobView" (click)="goBack();"><i class="fa fa-chevron-left"></i></span>
            <h4 style="display: inline-block;"> Material Consumption</h4>    
            <span style="float: right;">
                <span class="label brdrRadius3 " (click)="openItemSelect(selectItem)" *ngIf="jobDetails[0].StatusID != 2"
                 style="cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                    <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px;vertical-align: sub; padding-top: 8px;"></i>
                </span>
                <span style="cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; display: inline !important; margin-left: 10px; display: none !important;" class="webView closeMdl" (click)="goBack();">
                    <i class="zmdi zmdi-close"></i>
                </span>
            </span>

            <div class="IsRn" style="margin-top: 10px">
                <span class="btn orangeButton " (click)="openTransaction(6)"*ngIf="prductData.bom.length > 0 && jobDetails[0].StatusID != 2" style="padding: 5px 10px; font-size: 13px; margin-right: 10px;"> 
                    <i style="font-size: 13px !important;" class="fa fa-sign-out" aria-hidden="true"></i> Issue</span>
                <span class="btn orangeButton" (click)="openTransaction(7)" *ngIf="prductData.bom.length > 0" style="padding: 5px 10px ; font-size: 13px;"> 
                    <i style="font-size: 13px !important;" class="fa fa-sign-in" aria-hidden="true"></i> Return</span>
            </div>

        </div>
         <!-- Body -->
        <div class="col-md-12 col-12 col-sm-12 headerPadding DivPad"> 
            
                
            <!-- Product Name -->
            <!-- <div class="col-md-12 col-12 col-sm-12 bgWhite" style="padding-bottom: 10px; padding-left: 15px;">
                <div class="col-md-12 col-12 col-sm-12" style="font-size: 22px; padding-left: 0px;">
                    <span style="color: #E88421;">
                        <i class="zmdi zmdi-widgets"></i> {{prductData.productName}}
                    </span>  
                </div>
            </div> -->

            <!-- Item List -->
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <div *ngIf="prductData.bom.length > 0">
                    
                    <div class="marginTp" *ngFor="let P of prductData.bom; let i = index">                    
                        <div class="col-md-12 col-12 col-sm-12 pad0">
                            <div>
                                <div class="col-md-4 col-4 col-sm-4 pad0 inLneBlk">
                                    <span class="font14 darkBlueText" style="margin-left: 20px;">{{P.productName}}</span><br>
                                </div>
                                <div class="col-md-8 col-8 col-sm-8 pad0 inLneBlk txtRight" style="vertical-align: sub;">
                                    <span class="inLneBlk"> 
                                        <input type="text" id="txtItem"
                                        class="form-control " tabindex="1" [(ngModel)]="P.PQty"  placeholder="Qty"
                                        style=" height: 20px; padding: 15px; width: 80px; background: inherit; text-align: right;" (keyup)="checkPrecision(P)"
                                        maxlength="50" *ngIf="P.IsSelect" />
                                        <span *ngIf="!P.IsSelect" class="inLneBlk" style="margin-right: 5px;font-size: 13px;color: #777;">Plan: {{P.PQty}}</span>
                                    </span>
                                    <span class="inLneBlk" style="margin-right: 5px;font-size: 12px;color: #777;"> {{P.Unit}}</span>
                                    <span class="" style="padding: 2px 7px 2px; border-radius: 10px;color: gray; cursor: pointer;" *ngIf="(!P.IsSelect) && (P.usedQty == 0)"><i class="fa fa-trash-o" (click)="removeBOM(i)"></i></span>
                                    <span class="" style="padding: 2px 7px 2px; border-radius: 10px; cursor: pointer; color: #e88421;" *ngIf="!P.IsSelect" (click)="editQty(P,i)"><i class="fa fa-pencil" ></i></span>
                                    <span class="" style="padding: 2px 7px 2px; border-radius: 10px; cursor: pointer; color: #4caf50;" *ngIf="P.IsSelect" (click)="save()"><i class="fa fa-check"></i></span>
                                    <span class="" style="padding: 2px 7px 2px; border-radius: 10px; cursor: pointer; color: #777; padding-left: 0px;" *ngIf="P.IsSelect" (click)="cancel(P)"><i class="fa fa-times"></i></span>
                                
                                </div>
        
                                <div class="col-md-12 col-lg-12 col-12" style="padding: 0px;margin-left: 20px;">
                                    <div class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="display: inline-block; margin-bottom: 10px; font-size: 12px; padding: 3px 15px;">
                                        <span class="inLneBlk">Stock {{P.CurrQty}}</span>
                                        <!-- <span class="inLneBlk">Stock {{P.CurrQty}} {{P.Unit}}</span> -->
                                    </div>
                                    <div class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="display: inline-block;  margin-left: 8px; font-size: 12px; padding: 3px 15px;">
                                        <span class="inLneBlk"> Used {{P.usedQty}}</span>
                                        <!-- <span class="inLneBlk"> Used {{P.usedQty}} {{P.Unit}}</span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="bgWhite pad15 marginTp" *ngFor="let P of prductData.bom; let i = index" style="padding-right: 15px;">                    
                        <div class="col-md-12 col-12 col-sm-12 pad0">
                            <div>
                                <div class="col-md-7 col-7 col-sm-7 pad0 inLneBlk"> 
                                    <span class="font14">{{P.productName}}</span>
                                </div>
                                <div class="col-md-5 col-5 col-sm-5 pad0 inLneBlk txtRight">
                                    <span class="lableBtnGray" style="padding: 2px 7px 2px; border-radius: 10px;"><i class="fa fa-trash-o" (click)="removeBOM(i)"></i></span>
                                </div>
                            </div>
                            <div>
                                <div class="col-md-7 col-7 col-sm-7 pad0 inLneBlk">
                                    <span class="font14" style="margin-bottom: 0px;color: #777;">{{P.productCode}}</span>
                                </div>
                                <div class="col-md-5 col-5 col-sm-5 pad0 inLneBlk" style="text-align: right;">
                                    <span class="inLneBlk" style="width: min-content;"> 
                                        <input type="text" id="txtItem"
                                            class="form-control " tabindex="1"  [(ngModel)]="P.ReqdQty"  placeholder="Qty" title="Item Name"  captalize-first
                                            style=" height: 20px;padding: 15px; width: 80px; background: inherit; text-align: right;"
                                            maxlength="50"/>
                                    </span>
                                    <span class="inLneBlk font14"> {{P.Unit}}</span>
                                </div>
                            </div>
                        </div>
                    </div> -->
                <!-- Stage Save -->
                <!-- <div class="col-md-12 col-12 col-sm-12 bgWhite" style="padding-top: 10px;" (click)="save()">
                    <div class="btn btn-green">
                        <i class="fa fa-check"></i> Save
                    </div>
                </div> -->
            </div>
           
                <div class="bgWhite" style="padding-top: 10px !important;"  *ngIf="prductData.bom.length == 0">
                    <div class="nrf brdrRadius3" (click)="openItemSelect(selectItem);" style="margin-left: 15px;">
                        Click here to add a raw material.
                    </div>
                </div>

              
            </div>
        </div>
    </div>

    <div *ngIf="prductData.bom.length == 0" class="webView" style="width: 100%;">
        <div (click)="openItemSelect(selectItem)" 
            class="btn-darkBlue brdrRadius3 inLneBlk" style="padding: 4px 14px 4px; font-size: 13px;"> 
            <i class="zmdi zmdi-plus"></i> Issue Material
        </div>
    </div>
    <div *ngIf="prductData.bom.length > 0" class="webView" style="width: 100%;">
        <div style="color: #e88421; font-size: 16px; font-weight: 500;">
            <span style="margin-left: 5px;">Material Consumption ({{prductData.bom.length}})</span>
            <div class="btn btn-darkBlue brdrRadius3" (click)="openItemSelect(selectItem)" title="Select Materials" *ngIf="jobDetails[0].StatusID != 2"
                style="padding: 1px 9px; font-size: 16px; line-height: 1.66em; float: right; margin-right: 5px; padding-bottom: 0px;"> 
                    <i class="zmdi zmdi-plus" aria-hidden="true"></i>
            </div>
            <!-- <span style="float: right; font-size: 19px; cursor: pointer;" (click)="openItemSelect(selectItem)"><i class="zmdi zmdi-plus"></i></span> -->
            <div class="btn btn-orange brdrRadius3" (click)="openTransaction(6)" *ngIf="prductData.bom.length > 0 && jobDetails[0].StatusID != 2" 
                style="padding: 3px 13px 3px; font-size: 13px; line-height: 1.66em; margin-right: 5px; float: right;"> 
                    <i class="fa fa-sign-out" aria-hidden="true"></i> Issue
            </div>
            <div class="btn btn-orange brdrRadius3" (click)="openTransaction(7)" *ngIf="prductData.bom.length > 0" style="padding: 3px 13px 3px; font-size: 13px; line-height: 1.66em; margin-right: 5px; float: right;"> <i class="fa fa-sign-in" aria-hidden="true"></i> Return</div>
            <!-- <span style="float: right; font-size: 15px; cursor: pointer; margin-right: 5px;" *ngIf="!isEdit" (click)="isEdit = true"><i class="fa fa-pencil"></i></span> -->
            <!-- <span style="float: right; font-size: 20px; cursor: pointer;" (click)="fn_OpenBOM();" class="mobView"><i class="zmdi zmdi-plus"></i></span> -->
        </div>
        <div class="scrollbarSize" *ngIf="prductData.bom.length > 0" style="margin-top: 18px;overflow: initial;">
            
             <!-- New material consumtion table -->
             <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 5px; overflow-y: auto; max-height: 100%; font-size: 13px;">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th style="width: 30%;">Item</th>
                            <th style="width: 14%; text-align: right;">Used</th>	
                            <th style="width: 18%; text-align: right;">Plan</th>
                            <th style="width: 14%; text-align: right;">Available </th>
                            <th style="width: 14%;">Unit</th>
                            <th style="width: 6%;" *ngIf="isShowDel"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let P of prductData.bom; let i = index">
                            <td>{{P.productName}}</td>
                            <td style="text-align: right;">{{P.usedQty}}</td>
                            <td style="text-align: right; padding-right: 3px; padding-left: 3px;">	
                                <input type="text" id="txtItem"
                                    class="form-control " tabindex="1" [(ngModel)]="P.PQty"  placeholder="Qty"
                                    style=" height: 20px; width: 40px; display: inline-block;" (keyup)="checkPrecision(P)"
                                    maxlength="50" *ngIf="P.IsSelect" />

                                <span  class="" *ngIf="(!P.IsSelect)">                               
                                    {{P.PQty}}
                                </span>
                                <span class="" style="cursor: pointer; color: #e88421; display: inline-block; font-size: 13px; margin-left: 5px;" title="Edit" *ngIf="!P.IsSelect" (click)="editQty(P,i)"><i class="fa fa-pencil" ></i></span>
                                <span class="" style="cursor: pointer; color: #4caf50; display: inline-block; font-size: 13px; margin-right: 3px;" *ngIf="P.IsSelect" (click)="save()"><i class="fa fa-check"></i></span>
                                <span class="" style="cursor: pointer; color: #777; padding-left: 0px; display: inline-block; font-size: 13px;" *ngIf="P.IsSelect" (click)="cancel(P)"><i class="fa fa-times"></i></span>
                            </td>
                            <td style="text-align: right;">	
                                {{P.CurrQty}}
                            </td>
                            <td style="text-align: left;">	
                                {{P.Unit}}
                            </td>	
                            <td  *ngIf="isShowDel" style="text-align: right;">	
                                <span *ngIf="(!P.IsSelect) && (P.usedQty == 0)" class="" style="padding: 2px 7px 2px; border-radius: 10px;color: gray; cursor: pointer; display: inline-block; font-size: 13px;" title="Delete"><i class="fa fa-trash-o" (click)="removeBOM(i)"></i></span>
                            </td>           
                        </tr>
                    </tbody>
                </table>
            </div>
            
            
            <div class="marginTp" *ngFor="let P of prductData.bom; let i = index" style="display: none;">                    
                <div class="col-md-12 col-12 col-sm-12 pad0">
                    <div>
                        <div class="col-md-4 col-sm-4 col-xl-4 pad0 inLneBlk">
                            <span class="font14" style="color: #DAA520;">{{P.productName}}</span><br>
                        </div>
                        <div class="col-md-8 col-8 col-sm-8 pad0 inLneBlk " style="vertical-align: top; padding-top: 5px;">
                            <div style="display: inline-block; float: right; {{(P.usedQty == 0) ? '' : 'padding-right: 25px;'}}">
                                <div class="orangeBadge" style="display: inline-block; margin-right: -5px; font-size: 12px;">
                                    <span class="inLneBlk" style="color: {{P.usedQty > P.PQty ? 'red': ''}}"> Used {{P.usedQty}} </span>
                                </div>
                                <span>&nbsp; / &nbsp;</span>
                               
                                <input type="text" id="txtItem"
                                class="form-control " tabindex="1" [(ngModel)]="P.PQty"  placeholder="Qty"
                                style=" height: 20px; padding: 15px; width: 80px; margin-left:-5px; background: inherit; text-align: right; display: inline-block;" (keyup)="checkPrecision(P)"
                                maxlength="50" *ngIf="P.IsSelect" />
                                
                                <span *ngIf="P.IsSelect" class="inLneBlk font14" style="margin-right: 5px; font-size: 13px;color: #777;"> {{P.Unit}}</span>
                                <div  class="" *ngIf="(!P.IsSelect)" class="inLneBlk"
                                style="margin-right: 5px; font-size: 12px; display: inline-block; 
                                color: #daa520;background: #daa52018; padding: 6px 15px; margin-left: -5px; border-radius: 25px;font-weight: normal;display: inline-block;">                               
                                {{P.PQty}} {{P.Unit}} Plan
                                </div>

                                <!-- <span class="" style="padding: 2px 7px 2px; border-radius: 10px;color: gray; cursor: pointer;" *ngIf="(!P.IsSelect) && (P.usedQty == 0)"><i class="fa fa-trash-o" (click)="removeBOM(i)"></i></span> -->
                                <span class=""  style="border-radius: 10px; cursor: pointer; color: #e88421; display: inline-block;font-size: 13px;" title="Edit" *ngIf="!P.IsSelect" (click)="editQty(P,i)"><i class="fa fa-pencil" ></i></span>
                                <span class="" style="padding: 2px 7px 2px; border-radius: 10px;color: gray; cursor: pointer; display: inline-block; font-size: 13px;" title="Delete" *ngIf="(!P.IsSelect) && (P.usedQty == 0)" ><i class="fa fa-trash-o" (click)="removeBOM(i)"></i></span>
                                <span class="" style="padding: 2px 7px 2px; border-radius: 10px; cursor: pointer; color: #4caf50; display: inline-block; font-size: 13px;" *ngIf="P.IsSelect" (click)="save()"><i class="fa fa-check"></i></span>
                                <span class="" style="padding: 2px 7px 2px; border-radius: 10px; cursor: pointer; color: #777; padding-left: 0px; display: inline-block; font-size: 13px;" *ngIf="P.IsSelect" (click)="cancel(P)"><i class="fa fa-times"></i></span>
                            </div>
                        </div>
                        <div class="col-md-12 col-12 col-sm-12 pad0">                            
                            <div class="col-md-4 col-sm-4 col-xl-4 pad0 inLneBlk"></div>
                            <div class="col-md-8 col-8 col-sm-8 pad0 inLneBlk"  style="vertical-align: top; text-align: right;">
                                <div class="greenBadge" style="display: inline-block; margin-bottom: -6px; margin-top: 10px; font-size: 12px;  margin-right:40px;">
                                    <span class="inLneBlk">{{P.CurrQty}} {{P.Unit}}  available</span>
                                    <!-- <span class="inLneBlk">Stock {{P.CurrQty}} {{P.Unit}}</span> -->
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-md-12 col-lg-12 col-12" style="padding: 0px; display: none;">
                            <div class="orangeBadge" style="display: inline-block; margin-bottom: 10px; font-size: 12px; padding: 6px 15px;">
                                <span class="inLneBlk">Stock {{P.CurrQty}}</span>
                                <!-- <span class="inLneBlk">Stock {{P.CurrQty}} {{P.Unit}}</span> -->
                            </div>

                            <div class="greenBadge" style="display: inline-block;  margin-left: 5px; font-size: 12px; padding: 6px 15px;">
                                <span class="inLneBlk"> Used : {{P.usedQty}}</span>
                                <!-- <span class="inLneBlk"> Used {{P.usedQty}} {{P.Unit}}</span> -->
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

            <!-- Stage Save -->
            <div class="col-md-12 col-12 col-sm-12" style="padding-top: 10px; padding-left: 0px; display: none;">
                <div class="btn btn-green brdrRadius3" style="line-height: 30px;" *ngIf="isEdit" >
                    <i class="zmdi zmdi-check"></i> Save
                </div>
            </div>
        </div>

        <!-- <div style="position: absolute; text-align: center;left: 35%;bottom: 3%;"  >
            <div class="btn btn-yellow" (click) = "openTransaction(6)" style="padding: 5px 14px 4px; font-size: 14px; line-height: 1.66em;margin-right: 15px;"> <i class="fa fa-sign-out" aria-hidden="true"></i> Issue</div>
            <div class="btn btn-green" (click) = "openTransaction(7)" style="padding: 5px 14px 4px; font-size: 14px; line-height: 1.66em;"> <i class="fa fa-sign-in" aria-hidden="true"></i> Return</div>
        </div> -->

    
        <div *ngIf="prductData.bom.length == 0">
            <div class="nrf brdrRadius3" (click)="openItemSelect(selectItem);" *ngIf="jobDetails[0].StatusID != 2" style="margin-top: 15px; font-size: 13px; margin-left: 6px;">
                Click here to add a raw material.
            </div>
            <div class="nrf brdrRadius3" *ngIf="jobDetails[0].StatusID == 2" style="margin-top: 15px; font-size: 13px; margin-left: 6px; cursor: default;">
                No records found.
            </div>
        </div>

    
    </div>
</div>

<!-- Item Modal -->
<ng-template #selectItem let-modal>
    <button id="closeModalButton" data-toggle="modal" [hidden]="true"       
    data-target="#myModal" class="btn btn-default" (click)="closeModal()">Close</button>
    <!-- <app-multiple-select-item></app-multiple-select-item> -->
</ng-template>


    <!-- <div class="col-md-7 col-sm-7 col-7 pad0 font14 inLneBlk"
                                style="vertical-align: -webkit-baseline-middle;">
                                <h4 class="font14" style="margin-top: 10px;"> {{P.productName}}
                                </h4>
                                <h4 class="font14" style="margin-bottom: 0px;color: #777;">{{P.productCode}}</h4>
                            </div>
                            <div class="col-md-5 col-sm-5 col-5 inLneBlk pad0" style="text-align: right;">
                                <span class="inLneBlk" style="width: min-content;"> 
                                    <input type="text" id="txtItem"
                                        class="form-control " tabindex="1"  [(ngModel)]="P.ReqdQty"  placeholder="Qty" title="Item Name" captalize-first
                                        style=" height: 20px;padding: 15px; width: 80px; background: inherit; text-align: right;"
                                        maxlength="50" />
                                </span>
                                <span class="inLneBlk font14"> {{P.Unit}}</span>
                            </div> -->
